export enum NizzaEventStatus {
  CREATED = 'CREATED',
  STARTING = 'STARTING',
  LIVE = 'LIVE',
  FINALIZED = 'FINALIZED',
}
